(function ($) {
  const $snsslider = $('.sns_slide');
  $snsslider.slick({
    infinite: true,
    arrows: false,
    dots: false,
    autoplay: true,
    variableWidth: true,
    autoplaySpeed: 2000,
    centerMode: true
  });
})($224);
